<template>
  <div>

    <div class="headline mt-0 blue--text">1. Cancelling HawkSoft Text Messaging</div>

    <v-row align-center>
      <v-col class="col-12 align-self-baseline">
        <div class="mb-2">If you wish to stop using hawkSoft Text Messaging, please note the following:</div>
        <ol>
          <li>
            Any messages your clients send to this texting number will no longer be delivered to you. Please notify your clients of this change before cancelling
          </li>
          <li>
            You may get a copy of your text messaging data and attachments before you cancel HawkSoft Text Messaging
          </li>
          <li>
            HawkSoft will retain the phone number and data until you have downloaded your text messaging data and complete cancellation.
            <ol type="a">
              <li>If you wish to port your texting number to another service, please do so before cancelling HawkSoft Text Messaging</li>
            </ol>
          </li>
          <li v-if="featureOn">
            You will no longer be charged for HawkSoft Text Messaging. Any changes to HawkSoft Text Messaging will reflect on your next HawkSoft invoice.
          </li>
        </ol>
      </v-col>
    </v-row>

    <v-layout wrap>
      <v-flex xs12 sm10>
        <v-checkbox
          v-model="localValue"
          :disabled="localValue === true"
          :readonly="localValue === true"
          label="I understand that by cancelling HawkSoft Text Messaging, I will no longer have access to HawkSoft Text Messaging and my agency will no longer receive texts that clients send to your agency texting number."
          class="caption"
          hide-details
        />
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: 'TextingConfirmCancel',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    featureOn: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    localValue: {
      get () { return this.value; },
      set (val) { this.$emit('input', val); }
    }
  }
};
</script>
